import { Tabs, TabsList, TabsTrigger } from "../../ui/tabs";
import { AUDIT_CATEGORIES, type AuditCategoryId } from "./eventCategories";

interface AuditLogFilterChipsProps {
  /** `null` means "All" — the feed then sends no `event_types` param. */
  value: AuditCategoryId | null;
  onChange: (value: AuditCategoryId | null) => void;
}

/**
 * Category filter for the audit log drawer, rendered with the app's shared
 * tab set (see AuditSessionTabs) so the drawer matches the workpaper header.
 */
export function AuditLogFilterChips({
  value,
  onChange,
}: AuditLogFilterChipsProps) {
  return (
    <Tabs
      value={value ?? "all"}
      onValueChange={(next) => {
        const match = AUDIT_CATEGORIES.find((category) => category.id === next);
        onChange(match ? match.id : null);
      }}
    >
      <TabsList>
        <TabsTrigger value="all">All</TabsTrigger>
        {AUDIT_CATEGORIES.map((category) => (
          <TabsTrigger key={category.id} value={category.id}>
            {category.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
